const EMAIL_REGEX = /^[\w-.]+@(?:[\w-]+\.)+[a-zA-Z0-9]{2,4}/

export function checkEmail(email: string | null | undefined): boolean {
  return !!email && EMAIL_REGEX.test(email)
}
